<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5">
            <el-input size="medium" placeholder="搜索关键字: 标题" v-model="key" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button size="medium" type="primary" @click="searchArticle" icon="el-icon-search">搜索</el-button>
          </el-col>
          <el-col :span="13">
            &nbsp;
          </el-col>
          <el-col :span="4">
            &nbsp;
            <el-button size="medium" type="success" @click="linkTo('/popularize/writings/add')"
              v-if="checkButtonPermission('popularize:manage:writings:add')">新增海报文章</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border fixed min-height="400" style="width: 100%">
          <el-table-column prop="sort" label="排序" min-width="40" />
          <el-table-column prop="title" label="文章标题" min-width="100" />
          <el-table-column prop="createTime" label="生成时间" min-width="120" />
          <el-table-column prop="readCount" label="阅读次数" min-width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.readCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">停用</span>
              <span v-else-if="scope.row.status == 1">正常</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="openDialog('edit', scope.row)" type="success"
                v-if="checkButtonPermission('popularize:manage:writings:edit')">编辑
              </el-button>

              <el-button v-if="scope.row.status != 0 && checkButtonPermission('popularize:manage:writings:enable')"
                style="background-color: #7266ba; border-color: #7266ba;" type="success" size="mini"
                @click="enableArticle(scope.row.writingsId, false)">禁用
              </el-button>

              <el-button v-else-if="scope.row.status != 1 && checkButtonPermission('popularize:manage:writings:enable')"
                style="background-color: #7266ba; border-color: #7266ba;" type="success" size="mini"
                @click="enableArticle(scope.row.writingsId, true)">启用
              </el-button>

              <el-button type="danger" @click="deleteArticle(scope.row.writingsId)" size="mini"
                v-if="checkButtonPermission('popularize:manage:writings:delete')">删除
              </el-button>

            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" @closed="resetForm('articleForm')" :title="dialogTitle + '海报文章'"
      :modal="false" :close-on-click-modal="false">
      <el-form :model="articleForm" ref="articleForm" :rules="articleFormRules" label-width="120px" size="medium"
        style="padding-right: 10%;">
        <el-form-item label="排序" prop="sort">
          <el-input-number clearable v-model="articleForm.sort" :min="1" :max="999999"></el-input-number>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="articleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="endTime">
          <el-select v-model="articleSelect" @change="articleSelectChange" placeholder="请选择状态">
            <el-option v-for="item in articleStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <writings-edit v-on:listenToChildEvent="showMsgFromEdit"
            :parent-content="articleForm.content"></writings-edit>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary" :loading="loading"
            @click="submitPosterForm('articleForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import { reqCode, dialogAction } from '@/common/const';
import writingsEdit from "../../../components/plugins/edit/writingsEdit";
export default {
  name: "writingsList",
  components: { writingsEdit },
  data() {
    return {
      key: '',
      channels: [],
      selectedChannels: [],
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      createTime: [],
      dialogType: 'add',
      dialogTitle: '编辑',
      dialogVisible: false,
      articleForm: {
        content: `<br/><br/><br/><br/><br/>`
      },
      articleFormRules: {},
      articleStatusOptions: [
        {
          label: '禁用',
          value: 0
        },
        {
          label: '正常',
          value: 1
        },
      ],
      articleSelect: '',
      articleSelectVal: -1,
      hideThumbnail: false,
      thumbnailLimit: 1,
      thumbnailFileList: [],
      loading: false
    }
  },
  created() {
    this.searchArticle();
  },
  methods: {
    articleSelectChange(val) {
      this.articleSelectVal = val;
      this.articleForm.status = val;
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    show(data) {
      console.log(data);
    },
    showMsgFromEdit(data) {
      this.articleForm.content = data;
    },
    searchArticle() {
      let reqParam = {
        key: this.key,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$http.post('/api/popularize/writings/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    updateArticle(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/popularize/writings/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            this.loading = false
            let data = resp.data;
            if (data.code === "success") {
              this.$message({
                message: '编辑海报文章成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.searchArticle();
            } else {
              this.$alert('' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
            this.$alert('' + e, '温馨提示', {
              confirmButtonText: '确定'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteArticle(writingsId) {
      this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/popularize/writings/delete?writingsId=' + writingsId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.dialogVisible = false;
            this.$message({
              message: '删除海报文章成功',
              type: 'success'
            });
            this.searchArticle();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    enableArticle(writingsId, enable) {
      let text = '';
      let reqParam = {
        writingsId: writingsId
      };

      if (enable) {
        text = '启用';
        reqParam.status = 1;
      } else {
        text = '禁用';
        reqParam.status = 0;
      }

      this.$confirm('此操作将' + text + '海报文章, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/popularize/writings/enable', reqParam, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.dialogVisible = false;
            this.$message({
              message: text + '海报文章成功',
              type: 'success'
            });
            this.searchArticle();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchArticle();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchArticle();
    },
    openDialog(dialogType, data) {

      if ('add' == dialogType) {
        this.dialogType = 'add';
        this.articleForm.content = '';
      } else if ('edit' == dialogType) {
        this.dialogType = 'edit';
        let tmp = {};
        Object.assign(tmp, data);
        this.articleForm = tmp;
        let status = tmp.status;
        if (0 == status) {
          this.articleSelect = '禁用';
        } else if (1 == status) {
          this.articleSelect = '正常';
        }
        this.articleSelectVal = status;
      } else if ('info' == dialogType) {
        this.dialogType = 'info';
      }
      this.dialogVisible = true;
    },
    submitPosterForm(formName) {
      this.loading = true
      let reqParam = {
        writingsId: this.articleForm.writingsId,
        title: this.articleForm.title,
        content: this.articleForm.content,
        status: this.articleForm.status,
        sort: this.articleForm.sort,
      };
      this.updateArticle(formName, reqParam);

    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.createTime = [];
        this.articleForm = {
          content: `<br/><br/><br/><br/><br/>`
        };
        this.articleSelect = '';
        this.articleSelectVal = -1;
        this.$refs[formName].resetFields();
      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/popularize/writings/writingsList.vue